import { render, staticRenderFns } from "./widget-contact.vue?vue&type=template&id=a0634b26&"
import script from "./widget-contact.vue?vue&type=script&lang=js&"
export * from "./widget-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports